import Layout from "components/Layout/Layout";
import { ROOT_ROUTE_FOR_ROLE } from "model/routing";
import navigationMenuItems from "model/routing/navigationMenuItems";
import { useOrganizationId, useRole, useUsername } from "redux/auth/selectors";
import useGATracker from "../useGATracker";
import { ROUTES } from "./allRoutesList";
import { isAlpha, isLocal } from "../../configuration/endpoints";

function NavigationLayout({ children }) {
  const organizationId = useOrganizationId();
  const role = useRole();
  const username = useUsername();
  const rootRouteName =
    (role && ROOT_ROUTE_FOR_ROLE[role]) || ROOT_ROUTE_FOR_ROLE.DEFAULT;
  const rootPath = ROUTES?.[rootRouteName]?.path;
  useGATracker(role, organizationId);

  if (!role) return null;

  //Feature flag check will be down in individual menu item component
  const allowedMenuItems = navigationMenuItems.filter((mi) => {
    const isItemWhitelisted = !mi.whitelistRoles || mi.whitelistRoles[role];
    const isItemBlacklisted = mi.blacklistRoles && mi.blacklistRoles[role];
    const isUserWhitelisted =
      !mi.whitelistUsers || mi.whitelistUsers.includes(username);
    return (
      isItemWhitelisted &&
      isUserWhitelisted &&
      !isItemBlacklisted &&
      !mi.isHidden &&
      (!mi.alphaOnly || isAlpha || isLocal)
    );
  });

  return (
    <Layout
      navigationMenuItems={allowedMenuItems}
      rootPath={rootPath}>
      {children}
    </Layout>
  );
}

export default NavigationLayout;
